var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdirLogoMainEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 775.4 280",
    style: {
      enableBackground: "new 0 0 775.4 280"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#005E5D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "186.6,0 140,46.6 93.3,0 0,0 0,280 93.3,280 93.3,248.8 186.6,248.8 186.6,280 280,280 280,0  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M388,46.6v52h-7.3l-22.7-37.9v37.9h-7.8v-52h7.5l22.5,37.6V46.6H388z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.6,80.8c0-11.2,8.5-18.2,18.5-18.2s18.6,7.1,18.6,18.2s-8.5,18.5-18.5,18.5S397.6,92,397.6,80.8z  M427.2,80.8c0.5-6.1-4.2-11.5-10.3-11.9s-11.5,4.2-11.9,10.3c0,0.5,0,1.1,0,1.6c0,6.9,5.1,11.5,11.1,11.5c6.1,0,11.1-4.9,11.1-11 C427.2,81.1,427.2,81,427.2,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.7,63.8l-1.3,7c-1.6-0.8-3.4-1.2-5.2-1.2c-6.4,0-9.4,6.7-9.4,16.2v12.7h-7.5V63.3h7.5v7.9 c1.8-6.2,5.3-8.7,9.9-8.7C462.8,62.5,464.9,63,466.7,63.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M524.9,63.3L512,98.6h-6.3l-9.1-25.3l-8.8,25.3h-6.1l-13.4-35.2h8l8.5,24.1l8.4-24.1h6.9l8.4,24.1l8.4-24.1 H524.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M564.2,83.9h-28c1,5.7,5.2,8.5,10.9,8.5c4.1,0,7.9-1.7,9.9-5l5.9,3c-3.1,5.9-9.4,8.9-16.1,8.9 c-10.2,0-18.2-7.3-18.2-18.5s8.1-18.2,18.2-18.2c10,0,17.7,7.1,17.7,18.2C564.3,81.7,564.2,82.8,564.2,83.9z M556.9,77.9 c-0.7-5.5-4.8-8.5-10.2-8.5c-5.4,0-9.5,2.7-10.6,8.5H556.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M607.7,63.3v29.9c0,16.4-7.5,22.9-19.4,22.9c-6.8,0-13-3.7-16.1-9.7l6.3-3.1c2,3.7,5.7,6,9.9,6 c7.4,0,12-4.2,12-15.4v-0.5c-2.4,3.9-7.5,5.9-12.1,5.9c-9.6,0-17.5-7.2-17.5-18.4s7.9-18.3,17.4-18.3c4.9,0,9.8,2,12.2,5.9v-5.2 H607.7z M600.3,80.8c0-6.2-4.9-11.2-11.1-11.2c-0.1,0-0.1,0-0.2,0c-6-0.1-10.9,4.7-10.9,10.7c0,0.2,0,0.3,0,0.5 c0,6.6,4.9,11.5,10.9,11.5c6.1,0.1,11.1-4.7,11.2-10.7C600.3,81.3,600.3,81.1,600.3,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.4,50.5c0.2-2.8,2.6-4.9,5.4-4.7c2.5,0.2,4.6,2.2,4.7,4.7c-0.2,2.8-2.6,4.9-5.4,4.7 C619.6,55.1,617.6,53.1,617.4,50.5z M618.7,63.3h7.4v35.2h-7.4V63.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M672,63.3v35.2h-7.4v-5.3c-2.3,4-7.4,6-12.1,6c-9.6,0-17.5-7.2-17.5-18.4s7.9-18.3,17.4-18.3c5,0,9.9,2,12.2,6 v-5.2H672z M664.6,80.8c0-6.2-4.9-11.2-11.1-11.2c-0.1,0-0.1,0-0.2,0c-6-0.1-10.9,4.7-10.9,10.7c0,0.2,0,0.3,0,0.5 c0,6.6,4.9,11.5,10.9,11.5c6.1,0.1,11.1-4.7,11.2-10.7C664.6,81.3,664.6,81.1,664.6,80.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M716,78.4v20.1h-7.4V78.9c0-5.7-3.5-9.1-8-9.1s-10.2,2.6-10.2,9.9v18.8H683V63.3h7.4v5.4 c2-4.3,7.7-6.2,11.5-6.2C710.8,62.6,716.1,68.4,716,78.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M382,166.5v7.1h-31.9v-52h31.1v7.1h-23.5v15.8h20.4v7.2h-20.4v14.9L382,166.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.9,153.4v20.1h-7.4v-19.6c0-5.7-3.5-9.1-8-9.1s-10.2,2.6-10.2,9.9v18.8h-7.4v-35.2h7.4v5.4 c2-4.3,7.7-6.2,11.5-6.2C418.7,137.6,424,143.4,423.9,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.5,138.3l-14.7,35.2h-7l-14.7-35.2h7.9l10.3,25.6l10.2-25.6L465.5,138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M470.6,125.5c-0.2-2.8,2-5.2,4.7-5.4c2.8-0.2,5.2,2,5.4,4.7c0.2,2.8-2,5.2-4.7,5.4c-0.1,0-0.2,0-0.3,0 C472.9,130.4,470.7,128.2,470.6,125.5C470.6,125.5,470.6,125.5,470.6,125.5z M471.9,138.3h7.4v35.2h-7.4V138.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.8,138.8l-1.3,7c-1.6-0.8-3.4-1.2-5.2-1.2c-6.4,0-9.4,6.7-9.4,16.2v12.7h-7.5v-35.2h7.5v7.9 c1.8-6.2,5.3-8.7,9.9-8.7C509.8,137.5,511.9,138,513.8,138.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M516.9,155.8c0-11.2,8.4-18.2,18.5-18.2c10,0,18.6,7.1,18.6,18.2c0,11.2-8.5,18.5-18.6,18.5 C525.3,174.3,516.9,167,516.9,155.8z M546.5,155.8c0.2-6.1-4.6-11.3-10.8-11.5c-6.1-0.2-11.3,4.6-11.5,10.8c0,0.2,0,0.4,0,0.7 c0,6.9,5,11.5,11.1,11.5c6.1,0.1,11.1-4.8,11.2-11C546.5,156.2,546.5,156,546.5,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M595.6,153.4v20.1h-7.4v-19.6c0-5.7-3.5-9.1-8-9.1s-10.2,2.6-10.2,9.9v18.8h-7.4v-35.3h7.4v5.4 c2-4.3,7.7-6.2,11.5-6.2C590.4,137.6,595.7,143.4,595.6,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M661.7,153.4v20.1h-7.5v-19.6c0-5.8-3-9.2-7.8-9.2c-5.1-0.1-8.4,3.5-8.8,8.8v20.1h-7.5v-19.7 c0-5.8-3-9.1-7.4-9.1c-4.6,0-9.3,2.8-9.3,10v18.9h-7.4v-35.3h7.4v5.6c1.6-3.9,6.2-6.3,11-6.3c4.9-0.2,9.4,2.6,11.5,7.1 c2.3-4.5,7.1-7.2,12.1-7.1C657,137.6,661.7,143.4,661.7,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M705.7,158.9h-28.1c1,5.7,5.2,8.5,10.9,8.5c4.1,0,7.9-1.7,9.9-5l5.9,2.9c-3.1,5.9-9.4,8.9-16.1,8.9 c-10.2,0-18.2-7.3-18.2-18.5s8.1-18.2,18.2-18.2c10,0,17.7,7.1,17.7,18.2C705.8,156.7,705.8,157.8,705.7,158.9z M698.4,152.9 c-0.7-5.5-4.8-8.5-10.2-8.5c-5.4,0-9.5,2.7-10.6,8.5H698.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M747.4,153.4v20.1H740v-19.6c0-5.7-3.5-9.1-8-9.1c-4.5,0-10.2,2.6-10.2,9.9v18.8h-7.4v-35.2h7.4v5.4 c2-4.3,7.7-6.2,11.5-6.2C742.2,137.6,747.5,143.4,747.4,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M775.4,144.5h-7.5v29h-7.4v-29h-6.3v-6.2h6.3v-13.2h7.4v13.2h7.5V144.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.8,235.8h-21.6l-4.8,13.1h-8.1l19.7-52h8.3l19.6,52h-8.1L377.8,235.8z M375.3,229l-8.2-22.4l-8.3,22.4 L375.3,229z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.1,213.7v29.9c0,16.4-7.5,22.9-19.4,22.9c-6.8,0.1-13-3.7-16.1-9.7l6.3-3.1c2,3.6,5.7,5.9,9.9,6 c7.4,0,12-4.2,12-15.4v-0.5c-2.4,3.9-7.5,5.9-12.1,5.9c-9.6,0-17.5-7.2-17.5-18.4s7.9-18.3,17.4-18.3c4.9,0,9.8,2,12.2,5.9v-5.1 L431.1,213.7z M423.6,231.2c0-6.2-4.9-11.2-11.1-11.2c-0.1,0-0.1,0-0.2,0c-6-0.1-10.9,4.7-10.9,10.7c0,0.2,0,0.3,0,0.5 c0,6.6,4.9,11.5,10.9,11.5c6.1,0.1,11.1-4.7,11.2-10.7C423.6,231.7,423.6,231.4,423.6,231.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.5,234.3h-28.1c1,5.7,5.2,8.5,10.9,8.5c4.1,0,7.9-1.7,9.9-5l5.9,2.9c-3.1,5.9-9.4,8.9-16.1,8.9 c-10.2,0-18.2-7.3-18.2-18.5s8.1-18.2,18.2-18.2s17.7,7.1,17.7,18.2C475.6,232.1,475.6,233.1,475.5,234.3z M468.3,228.3 c-0.7-5.5-4.8-8.5-10.2-8.5s-9.5,2.7-10.6,8.5L468.3,228.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M517.2,228.8v20.1h-7.4v-19.6c0-5.7-3.5-9-8-9s-10.2,2.6-10.2,9.9v18.8h-7.4v-35.2h7.4v5.4 c2-4.3,7.7-6.2,11.5-6.2C512,212.9,517.3,218.7,517.2,228.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M525.5,231.3c0-11.2,8.8-18.3,19-18.3c5.2-0.1,10.3,2.1,13.7,6l-4.9,4.6c-2.2-2.4-5.4-3.7-8.7-3.7 c-6.6,0-11.8,4.7-11.8,11.4s5.2,11.4,11.8,11.4c3.3,0.1,6.4-1.3,8.7-3.7l4.9,4.6c-3.5,3.9-8.5,6.1-13.7,6 C534.3,249.6,525.5,242.4,525.5,231.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M597.6,213.7L575.8,266h-7.8l7.5-18.6l-14-33.7h8l10.1,24.5l10.1-24.5H597.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdirLogoMainEn);
export default __webpack_public_path__ + "static/media/MdirLogo_Main_En.395fa99b33685606188bb58beaaa2173.svg";
export { ForwardRef as ReactComponent };